import { AuditName } from "../enums";

export const getWebUrlPrefix = auditName => {
    let webUrl;
    switch (auditName) {
        case AuditName.ACCOUNT:
            webUrl = '/accounting/accounts';
            break;
        case AuditName.CONTACT:
            webUrl = '/contacts';
            break;
        case AuditName.PRODUCT:
            webUrl = '/products';
            break;
        default:
            throw new Error('Invalid auditName');
    }
    return webUrl;
};
